<template>
  <div class="container">

    <div class="row">
      <div class="col-md-12 mt-2 mb-3">
        <h1>Orhideje</h1>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">

        <Loading :active.sync="isLoading"
                 :can-cancel="false"
                 :is-full-page="false"></Loading>

        <div class="row" v-if="orchids">
          <div class="col-md-3 mb-3 offset-md-9 text-right">
            <vue-excel-xlsx
                class="btn btn-primary btn-sm text-white btn-block"
                :data="orchids"
                :columns="excelColumns"
                :filename="'orhideje'"
                :sheetname="'Orhideje'"
            ><i
                class="fas fa-file-excel"></i> Prenesi xls datoteko
            </vue-excel-xlsx>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">

            <b-tabs content-class="mt-3" v-model="selectedYearTab">
              <b-tab v-for="(year, index) in availableYears" :key="year" :title="year.toString()" :active="index === 0">
              </b-tab>
            </b-tabs>

            <vue-good-table
                v-if="orchids"
                styleClass="vgt-table table table-hover table-striped"
                :columns="columns"
                :rows="orchids"
                :pagination-options="{
    enabled: true,
    mode: 'records',
    perPage: 10,
    position: 'top',
    perPageDropdown: [5, 10, 20, 50],
    dropdownAllowAll: true,
    setCurrentPage: 1,
    jumpFirstOrLast : true,
    firstLabel : 'Prva stran',
    lastLabel : 'Zadnja stran',
    nextLabel: 'nasl.',
    prevLabel: 'prej.',
    rowsPerPageLabel: 'Zadetkov na stran',
    ofLabel: 'od',
    pageLabel: 'stran', // for 'pages' mode
    allLabel: 'Vsi'
  }"
                :search-options="{
                                                        enabled: true,
                                                        skipDiacritics: true,
                                                        placeholder: 'vnesi iskalni pojem',
                                                        searchFn: searchFunc
                                                    }"
                :sort-options="{
              enabled: true,
              initialSortBy: {field: 'createdAt.seconds', type: 'desc'}
            }">

              <div slot="emptystate">
                <div class="text-center text-muted font-weight-light"><i class="fa fa-exclamation-triangle"></i> <em>Ni
                  podatkov.</em></div>
              </div>

              <template slot="table-row" slot-scope="props">

                <div v-if="props.column.field == 'createdAt.seconds'" style="width: 150px;">
                  {{ moment.unix(props.row.createdAt.seconds).format('DD. MM. YYYY, HH:mm') }}
                </div>
                <div v-if="props.column.field == 'species.siName'" style="width: 200px;">
                  {{ props.row.species.siName ? props.row.species.siName.toLowerCase() : 'n/a' }}<br/>
                  <small class="text-muted">{{ props.row.species.latinName }}</small>
                </div>
                <div v-if="props.column.field == 'location'" style="width: 50px;">
                  <a class="btn btn-primary btn-sm"
                     :href="'https://www.google.com/maps?q=' + props.row.latitude + ',' + props.row.longitude"
                     target="_blank"><i class="fa fa-map"></i></a>
                </div>

                <div v-if="props.column.field == 'photo'" style="text-align: center">
                  <!-- Basic image with loading placeholder -->
                  <div class="image-container" style="width: 100px; height: 100px; position: relative; margin: 0 auto;">
                    <!-- Loading indicator -->
                    <div v-if="!imageLoaded[props.row.id]" class="image-placeholder">
                      <div class="spinner"></div>
                    </div>
                    <!-- Actual image -->
                    <img 
                      :src="props.row.photo" 
                      @load="setImageLoaded(props.row.id)" 
                      :style="{
                        width: '100px',
                        height: '100px',
                        objectFit: 'contain',
                        display: imageLoaded[props.row.id] ? 'block' : 'none'
                      }" 
                      loading="lazy" 
                    />
                  </div>
                </div>

                <div v-if="props.column.field == 'createdBy'" style="width: 100px;">
                  <small class="text-muted">{{ props.row.createdBy }}</small>
                </div>


                <div v-if="props.column.field == 'id'" style="width: 240px;">
                  <a class="btn btn-success btn-sm text-white ml-1"
                     @click="showDetails(props.row)"><i
                      class="fa fa-search"></i> Več</a>

                  <a class="btn btn-primary btn-sm text-white ml-1"
                     @click="editDetails(props.row)"><i
                      class="fa fa-edit"></i> Uredi</a>

                  <a class="btn btn-danger btn-sm text-white ml-1"
                     @click="deleteDataConfirmation(props.row)"><i
                      class="fa fa-trash"></i> Odstrani</a>
                </div>
              </template>
            </vue-good-table>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 mt-3 mb-5">

            <router-link :to="{ name: 'List' }" class="btn btn-success">
              <i class="fa fa-plus"></i> Dodaj orhidejo
            </router-link>

          </div>
        </div>

      </div>
    </div>


    <b-modal ref="orchidsDetailsModal" title="Podrobnosti o zapisu" size="lg" hide-footer>

      <div v-if="selectedOrchid">

        <b-tabs content-class="mt-3">
          <b-tab title="Primerjalnik" active>
            <div class="row">
              <div class="col-md-6 mt-2 text-left">
                <i class="fa fa-chevron-left"></i> Fotografija opazovalca
              </div>
              <div class="col-md-6 mt-2 text-right">
                Reprezentativna fotografija vrste <i class="fa fa-chevron-right"></i>
              </div>

              <div class="col-md-12 mt-2">
                <img-comparison-slider>
                  <img slot="after" width="100%" :src="selectedOrchid.photo" class="img-fluid"
                       style="min-height: 500px;" loading="lazy">
                  <img slot="before" width="100%" :src="selectedOrchid.species.image" class="img-fluid"
                       style="min-height: 500px;" loading="lazy">
                </img-comparison-slider>
                <div class="text-muted small mt-2 text-center">
                  <i class="fas fa-info-circle"></i> Sliki se nalagata v celotni velikosti, kar lahko traja nekaj trenutkov.
                </div>
              </div>
            </div>
          </b-tab>
          <b-tab title="Opazovalčeva fotografija">
            <div class="row" v-if="selectedOrchid">
              <div class="col-12 text-center">
                <img :src="selectedOrchid.photo" class="img-fluid" loading="lazy">
                <div class="text-muted small mt-2">
                  <i class="fas fa-info-circle"></i> Slika se nalaga v celotni velikosti, kar lahko traja nekaj trenutkov.
                </div>
              </div>
            </div>
          </b-tab>
        </b-tabs>


        <div class="col-md-12 mt-5">

          <dl class="row">
            <dt class="col-sm-3">Ime</dt>
            <dd class="col-sm-9">{{ selectedOrchid.species.siName }}</dd>

            <dt class="col-sm-3">Latinsko ime</dt>
            <dd class="col-sm-9">{{ selectedOrchid.species.latinName }}</dd>

            <dt class="col-sm-3">Angleško ime</dt>
            <dd class="col-sm-9">
              {{ selectedOrchid.species.name }}
            </dd>

            <dt class="col-sm-3">Datum opazovanja</dt>
            <dd class="col-sm-9">{{ moment.unix(selectedOrchid.createdAt.seconds).format('DD. MM. YYYY, HH:mm') }}</dd>

            <dt class="col-sm-3">Lokacija nahajanja</dt>
            <dd class="col-sm-9">
              {{ selectedOrchid.latitude }}, {{ selectedOrchid.longitude }}
              <a class="btn btn-primary btn-sm ml-2"
                 :href="'https://www.google.com/maps?q=' + selectedOrchid.latitude + ',' + selectedOrchid.longitude"
                 target="_blank"><i class="fa fa-map"></i> Prikaži na zemljevidu</a></dd>

            <dt class="col-sm-3">Rastišče</dt>
            <dd class="col-sm-9">{{ selectedOrchid.site.siName }}</dd>

            <dt class="col-sm-3">Barva</dt>
            <dd class="col-sm-9">{{ selectedOrchid.color.siName }}</dd>

            <dt class="col-sm-3">Višina</dt>
            <dd class="col-sm-9">{{ selectedOrchid.height }} cm</dd>

            <dt class="col-sm-3">Število primerkov</dt>
            <dd class="col-sm-9">{{ selectedOrchid.count }}</dd>

            <dt class="col-sm-3">Komentar</dt>
            <dd class="col-sm-9">{{ selectedOrchid.comment ? selectedOrchid.comment : '/' }}</dd>

          </dl>

        </div>


        <div slot="modal-footer" class="w-100">
          <b-button
              variant="primary"
              class="float-right"
              @click="() => { selectedOrchid = null; $refs['orchidsDetailsModal'].hide(); }">
            Zapri
          </b-button>
        </div>

      </div>
    </b-modal>

  </div>

</template>

<style type="text/css">
.vgt-table img {
  max-width: 100px;
  max-height: 100px;
  object-fit: contain;
}

/* Placeholder for images while loading */
.image-placeholder {
  width: 100px;
  height: 100px;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 4px;
}

/* Spinner animation */
.spinner {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(0, 0, 0, 0.1);
  border-top-color: #09f;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Fade-in animation for images */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.img-fluid {
  animation: fadeIn 0.5s;
}

/* Container for table images */
.image-container {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

<script>
import firebase from 'firebase'
import 'firebase/storage'
import {db} from '../main'
import {VueGoodTable} from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import _ from 'lodash'


export default {
  name: 'Projects',
  components: {
    VueGoodTable,
    Loading,
  },
  data() {
    return {
      selectedYearTab: 0,
      isLoading: false,
      orchids: null,
      selectedOrchid: null,
      thumbnailCache: {},
      imageLoaded: {},
      availableYears: [],
      columns: [
        {
          label: 'Datum',
          field: 'createdAt.seconds',
          type: 'text',
          sortable: true,
        },
        {
          label: 'Ime',
          field: 'species.siName',
          type: 'text',
          sortable: true,
        },
        {
          label: 'Lokacija',
          field: 'location',
          type: 'text',
          sortable: false,
        },
        {
          label: 'Photo',
          field: 'photo',
          type: 'text',
          sortable: false,
          width: '200px'
        },
        {
          label: 'Akcije',
          field: 'id',
          type: 'text',
          sortable: false,
        },
      ],
      excelColumns: [
        {
          label: "Ime",
          field: "species",
          dataFormat: (val) => {
            return val.siName
          }
        },
        {
          label: "Latinsko ime",
          field: "species",
          dataFormat: (val) => {
            return val.latinName
          }
        },
        {
          label: "Angleško ime",
          field: "species",
          dataFormat: (val) => {
            return val.name
          }
        },
        {
          label: "Datum opazovanja",
          field: "createdAt",
          dataFormat: (val) => {
            console.log("val", val);
            return this.moment.unix(val.seconds).format('DD. MM. YYYY, HH:mm')
          }
        },
        {
          label: "Lokacija nahajanja - širina",
          field: "latitude",
          dataFormat: (val) => {
            return val
          }
        },
        {
          label: "Lokacija nahajanja - dolžina",
          field: "longitude",
          dataFormat: (val) => {
            return val
          }
        },
        {
          label: "Lokacija nahajanja na zemljevidu",
          field: "id",
          dataFormat: (val) => {
            return 'https://www.google.com/maps?q=' + _.filter(this.orchids, {id: val})[0].latitude + ',' + _.filter(this.orchids, {id: val})[0].longitude
          }
        },
        {
          label: "Rastišče",
          field: "site",
          dataFormat: (val) => {
            return val.siName
          }
        },
        {
          label: "Višina (cm)",
          field: "height",
          dataFormat: (val) => {
            return val
          }
        },
        {
          label: "Barva",
          field: "color",
          dataFormat: (val) => {
            return val.siName
          }
        },
        {
          label: "Število primerkov",
          field: "count",
          dataFormat: (val) => {
            return val
          }
        },
        {
          label: "ID zapisovalca",
          field: "createdBy",
          dataFormat: (val) => {
            return val
          }
        },
        {
          label: "ID v bazi",
          field: "id",
          dataFormat: (val) => {
            return val
          }
        },

      ],
    }
  },
  mounted() {
    // Initialize available years (current year down to 2021)
    const currentYear = new Date().getFullYear();
    this.availableYears = [];
    for (let year = currentYear; year >= 2021; year--) {
      this.availableYears.push(year);
    }
    
    this.retrieveData();
  },
  watch: {
    selectedYearTab() {
      this.retrieveData();
    }
  },
  methods: {
    retrieveData() {
      const _this = this

      _this.orchids = null;
      _this.isLoading = true;
      // Clear thumbnail cache when loading new data to prevent memory issues
      _this.thumbnailCache = {};
      // Reset the image loaded tracker
      _this.imageLoaded = {};

      let events = db.collection('orchids')

      // Get the selected year from the availableYears array
      const year = _this.availableYears[_this.selectedYearTab] || new Date().getFullYear();

      events
          .where('createdAt', '>=', _this.moment(year, 'YYYY').startOf('year').toDate())
          .where('createdAt', '<=', _this.moment(year, 'YYYY').endOf('year').toDate())
          .orderBy("createdAt", "desc")
          .get()
          .then(querySnapshot => {
            // Process data in chunks to prevent UI blocking
            const processData = () => {
              const docs = querySnapshot.docs;
              const chunkSize = 10; // Process 10 documents at a time
              
              // Function to process documents in chunks
              const processChunk = (startIndex) => {
                const endIndex = Math.min(startIndex + chunkSize, docs.length);
                const chunk = docs.slice(startIndex, endIndex);
                
                // Process this chunk
                const chunkData = chunk.map(doc => doc.data());
                
                // Append to existing data or create new array
                _this.orchids = _this.orchids ? [..._this.orchids, ...chunkData] : chunkData;
                
                // If we have more to process, schedule the next chunk
                if (endIndex < docs.length) {
                  setTimeout(() => processChunk(endIndex), 10);
                } else {
                  // All done!
                  console.log("Finished loading orchids:", _this.orchids.length);
                  _this.isLoading = false;
                }
              };
              
              // Start processing from the beginning
              processChunk(0);
            };
            
            // Start the processing
            processData();
          })
          .catch(function (error) {
            // The document probably doesn't exist.
            console.log('Error getting documents: ', error)
            _this.isLoading = false
          })
    },

    showDetails(orchidData) {
      const _this = this;
      _this.selectedOrchid = orchidData;
      
      // Preload the full-size image before showing the modal
      if (orchidData.photo) {
        const img = new Image();
        img.src = orchidData.photo;
      }
      
      _this.$refs['orchidsDetailsModal'].show();
    },

    editDetails(orchidData) {
      const _this = this;
      console.log("orchidData", orchidData);
      _this.$router.push({name: 'List', params: { id: orchidData.id }})
    },

    fixDates() {
      const _this = this;

      let events = db.collection('orchids')
      events
        .get()
        .then(querySnapshot => {

          let allOrchids = _.filter(querySnapshot.docs.map(doc => doc.data()), function (orchid) {
            return orchid.createdAt === null || orchid.createdAt === undefined;
          });
          console.log("allOrchids", allOrchids);

          _.each(allOrchids, async function (orchid,idx) {
              await _this.updateData(orchid.id);
          })


        })
        .catch(function (error) {
          // The document probably doesn't exist.
          console.log('Error getting documents: ', error)
          _this.isLoading = false
        })
    },

    async updateData(id) {
      const _this = this
      const currentOrchid = db.collection('orchids').doc(id)
      console.log("currentOrchid", currentOrchid);

      // Retrieve the document snapshot
      const docSnapshot = await currentOrchid.get();

      let createdAt = null;
      if (docSnapshot.exists) {
        // Get the field value
        createdAt = docSnapshot.get('updatedAt');
      }
      console.log("createdAt", _this.moment.unix(createdAt.seconds).toDate());



      return await currentOrchid.update({
        createdAt: createdAt && createdAt.seconds ? _this.moment.unix(createdAt.seconds).toDate() : new Date(),
      })
        .then(function () {

        })
        .catch(function (error) {
          console.error('Error updating event: ', error)
        })

    },

    deleteDataConfirmation(orchid) {
      const _this = this

      this.$swal({
        title: 'Opozorilo',
        text: 'Ali ste prepričani, da želite izbrisati ta zapis? Po potrditvi izbire ne bo več mogoče preklicati.',
        dangerMode: true,
        buttons: {
          cancel: {
            text: 'Prekliči',
            value: null,
            visible: true,
            className: '',
            closeModal: true,
          },
          confirm: {
            text: 'Izbriši',
            value: true,
            visible: true,
            className: '',
            closeModal: true
          }
        },
      })
          .then((value) => {

            switch (value) {

              case true:

                _this.deleteData(orchid.id)

              case null:

                return

                break

              default:

            }
          })
    },
    deleteData(id) {
      const _this = this

      db.collection('orchids').doc(id).delete()
          .then(function () {
            _this.retrieveData();
          })
          .catch(function (error) {
            // The document probably doesn't exist.
            console.error('Error deleting work hour report: ', error)
          })
    },

    searchFunc(row, col, cellValue, searchTerm) {
      const _this = this;
      if(row && searchTerm) {
        if (JSON.stringify(row).toLowerCase().includes(searchTerm.toLowerCase())) {
          return true;
        }
      }
    },
    
    setImageLoaded(id) {
      this.$set(this.imageLoaded, id, true);
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Orchids.vue